<template>
  <Dropdown
    placement="bottom"
    :options="localeStore.getLocaleList"
    :value="selectedKeys"
    overlayClassName="app-locale-picker-overlay"
    @change="handleLocaleChange"
  >
    <Tooltip :open="PADMode ? false : void 0" :title="t('g.25090005')">
      <span class="mx-8px flex cursor-pointer items-center">
        <MIcon prefix="g" icon="duoyuyan" :size="PADMode ? 22 : 18" />
        <span v-if="showText" class="ml-1">{{ getLocaleText }}</span>
      </span>
    </Tooltip>
  </Dropdown>
</template>
<script lang="ts" setup>
  import { Tooltip } from 'ant-design-vue';
  import { computed, ref, unref, watchEffect } from 'vue';
  import { $MTS, type LocaleType } from '@mts-fe/utils';
  import { Dropdown, type DropItem } from '@mts/components/Dropdown';
  import { t } from '@mts/hooks/web/useI18n';
  import { useLocale } from '@mts/locales/useLocale';
  import { PADMode } from '@mts/utils/env';
  import { getLocaleStore } from '@/store';

  const props = defineProps({
    /**
     * Whether to display text
     */
    showText: { type: Boolean, default: true },
    /**
     * Whether to refresh the interface when changing
     */
    reload: { type: Boolean },
  });

  const selectedKeys = ref<LocaleType[]>([]);

  const localeStore = getLocaleStore();
  const { changeLocale, getLocale } = useLocale();

  const getLocaleText = computed(() => {
    const key = selectedKeys.value[0];
    if (!key) {
      return '';
    }
    return localeStore.getLocaleList.find((item) => item.value === key)?.label;
  });

  watchEffect(() => {
    selectedKeys.value = [unref(getLocale)];
  });

  async function toggleLocale(lang: LocaleType) {
    await changeLocale(lang);
    selectedKeys.value = [lang];
    props.reload && $MTS.App.restart();
  }

  function handleLocaleChange(menu: DropItem) {
    if (unref(getLocale) === menu.value) {
      return;
    }
    toggleLocale(menu.value as LocaleType);
  }
</script>

<style lang="less">
  .app-locale-picker-overlay {
    .ant-dropdown-menu-item {
      min-width: 160px;
    }
  }
</style>
